// EmployeeCardUI.tsx
import {
  Box,
  Paper,
  Typography,
  Button,
  Avatar,
  IconButton,
  TextField,
  Grid,
  Collapse,
  Fade,
} from "@mui/material";
import { Trash2, Edit2, Check, X, ChevronDown } from "lucide-react";
import React from "react";

import { ImageDropzone } from "0.Mine/0.Components/Reusable/ImageDropzone";
import { Employee } from "0.Mine/3.Interfaces/Employee";
import ArgonDatePicker from "components/ArgonDatePicker";

import { EmployeeSchedule } from "./BusinessEmployee";

export interface EmployeeCardUIProps {
  employee: Employee;
  index: number;
  editing: boolean;
  editingData: Employee | null;
  expanded: boolean;
  startEditing: () => void;
  cancelEditing: () => void;
  saveEditing: () => void;
  toggleExpanded: () => void;
  handleDelete: () => void;
  handleEditingDataChange: (
    field: keyof (Employee & { services: string[] }),
    value: string
  ) => void;
  handleScheduleChange: (newSchedule: any) => void;
  handleFileUpload: (employeeId: number, file: File) => void;
}

export const EmployeeCardUI: React.FC<EmployeeCardUIProps> = ({
  employee,
  index,
  editing,
  editingData,
  expanded,
  startEditing,
  cancelEditing,
  saveEditing,
  toggleExpanded,
  handleDelete,
  handleEditingDataChange,
  handleScheduleChange,
  handleFileUpload,
}) => {
  return (
    <Fade in={true} timeout={500 + index * 200}>
      <Paper
        sx={{
          p: 3,
          borderRadius: 4,
          mb: 4,
          boxShadow:
            "0rem 0.25rem 0.375rem -0.0625rem rgba(20, 20, 20, 0.12), 0rem 0.125rem 14rem -0.0625rem rgba(20, 20, 20, 0.07)",
        }}
      >
        <Grid container spacing={2}>
          <Grid item>
            {editing && editingData ? (
              <ImageDropzone
                initialImage={employee.photo}
                onDropFile={(acceptedFile) => {
                  console.log(acceptedFile);
                  handleFileUpload(employee.id, acceptedFile);
                }}
                isMinified={true}
                width={70}
                height={70}
              />
            ) : (
              <Avatar src={employee.photo} alt={employee.name} sx={{ width: 80, height: 80 }} />
            )}
          </Grid>
          <Grid item xs>
            {editing && editingData ? (
              <>
                <TextField
                  fullWidth
                  size="small"
                  label="Nome"
                  value={editingData.name}
                  onChange={(e) => handleEditingDataChange("name", e.target.value)}
                  sx={{ mb: 1 }}
                />
                <TextField
                  fullWidth
                  size="small"
                  label="Ruolo"
                  value={editingData.role}
                  onChange={(e) => handleEditingDataChange("role", e.target.value)}
                />
                <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
                  <IconButton color="success" onClick={saveEditing}>
                    <Check />
                  </IconButton>
                  <IconButton color="default" onClick={cancelEditing}>
                    <X />
                  </IconButton>
                </Box>
              </>
            ) : (
              <>
                <Typography variant="h6" fontWeight="bold">
                  {employee.name}
                </Typography>
                <Typography color="text.secondary">{employee.role}</Typography>
              </>
            )}
          </Grid>
          <Grid item>
            <IconButton color="primary" onClick={startEditing}>
              <Edit2 />
            </IconButton>
            <IconButton color="error" onClick={handleDelete}>
              <Trash2 />
            </IconButton>
          </Grid>
        </Grid>

        <Typography fontWeight="bold" mt={2} sx={{ fontSize: "16px" }}>
          Servizi Offerti:
        </Typography>
        <Box>
          {employee.serviceNames.map((service) => (
            <Typography key={service} sx={{ fontSize: "16px" }} color="text.secondary">
              <img
                src="https://qlickup.it/wp-content/uploads/2025/04/arrow-button-e1744719855917.png"
                alt="freccia"
                width="15"
                height="auto"
              />{" "}
              {service}
            </Typography>
          ))}
        </Box>

        {/*<Typography fontWeight="bold" mt={2}>
                    Periodo di Ferie:
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <ArgonDatePicker
                            input={employee.workingHours}
                            value={{}}
                            onChange={() => console.log("Hello")}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <ArgonDatePicker
                            input={employee.workingHours}
                            value={{}}
                            onChange={() => console.log("Hello")}
                        />
                    </Grid>
                </Grid>*/}

        <Button
          fullWidth
          variant="outlined"
          sx={{ mt: 2 }}
          startIcon={<ChevronDown />}
          onClick={toggleExpanded}
        >
          Orari di Lavoro
        </Button>

        <Collapse in={expanded} timeout={500}>
          <Box sx={{ mt: 2 }}>
            <EmployeeSchedule
              schedule={employee.workingHours}
              onScheduleChange={handleScheduleChange}
            />
          </Box>
        </Collapse>
      </Paper>
    </Fade>
  );
};

export default React.memo(EmployeeCardUI);
